import { useQuery } from '@tanstack/react-query';
import { useFlags } from 'src/feature-flags/FlagsHook';
import { ConversationListItem } from './types';

export function useConversations(clientId?: string, familyId?: string, archived?: boolean) {
  const { flagEnabledSiestaChats } = useFlags();
  return useQuery<ConversationListItem[]>({
    // archived is left undefined (not false) for the main list so the queryKey and request URL stay
    // identical to before; the archived view passes true, giving it its own cache entry.
    queryKey: ['conversations', { clientId, familyId, archived }],
    // Backend returns 404 on this route when Siesta chats are off, so don't request it then.
    // Strict === true keeps the query disabled while LaunchDarkly is still loading and the flag
    // is undefined, which React Query would otherwise treat as enabled and fire a 404.
    enabled: flagEnabledSiestaChats === true,
    // Poll while the list is open so a turn moving to processing, then unread, shows without a manual refresh.
    refetchInterval: 4000,
  });
}
